<div class="card" >
  <app-header titulo="Cadastro de Pesagem" descricao="Digite as informações da Pesagem"></app-header>

  <div class="formgrid grid p-fluid">
        <div class="field col-4">
          <label for="empresaErp">Empresa ERP: </label>
          <p-dropdown
             appendTo="body"
             [options]="empresas"
             [filter]="true"
             optionValue="empresaErp"
             optionLabel="empresaErp"
             [(ngModel)]="pesagem.empresaErp"
             dataKey="id" inputId="id"
             placeholder="Código Empresa ERP"
              emptyMessage="Nenhuma código"
              >
            </p-dropdown>
        </div>
        <div class="field col-4">
          <label for="tanqueErp">Tanque Erp: </label>
          <input
            type="text"
            id="tanqueErp"
            maxlength="5"
            pInputText
            [(ngModel)]="pesagem.tanqueErp"
            required
          />
        </div>
        <div class="field col-4">
          <label for="cdMaterialErp">Código Material Erp: </label>
          <input
            type="text"
            id="cdMaterialErp"
            maxlength="200"
            pInputText
            [(ngModel)]="pesagem.cdMaterialErp"
            required
          />
        </div>
        <div class="field col-4">
          <label for="idTanquePi">Id Tanque Pi: </label>
          <input
            type="text"
            id="idTanquePi"
            maxlength="5"
            pInputText
            [(ngModel)]="pesagem.idTanquePi"
            required
          />
        </div>
        <div class="field col-4">
          <label for="cdMaterialPi">Código Material Pi: </label>
          <input
            type="text"
            id="cdMaterialPi"
            maxlength="20"
            pInputText
            [(ngModel)]="pesagem.cdMaterialPi"
            required
          />
        </div>
        <div class="field col-2 pt-4">
          <button
            pButton
            icon="pi pi-save"
            class="p-button-success"
            [label]="pesagem.id ? 'Atualizar' : 'Salvar'"
            (click)="salvar()"
          ></button>
        </div>
        <div class="field col-2 pt-4">
          <button
           pButton label="Cancelar"
           icon="pi pi-times"
           class="p-button-text"
           (click)="fecharDialog()"></button>
        </div>
  </div>
</div>
